export enum CookieName {
  accessToken = 'a',
  refreshToken = 'r',
  role = 'o'
}
